import React from "react";
import "./Clients.scss";

const Clients: React.FC = () => {
    const clients = [
        {
            image: "/template-blog-capa.png",
            title: "Blog",
            description: "Blog pessoal",
        },
        {
            image: "/template-cv-capa.png",
            title: "CV Portifólio Personalizado",
            description: "Crie um portifólio de clientes personalizado e CV e interativo",
        },
        {
            image: "/template-integracoes-capa.png",
            title: "Integrações",
            description: "Integrações com sua API ou API de terceiros para criação de dashboard, lista de clientes ou o que precisar",
        },
    ];

    return (
        <section className="clients-section wrapper" id="templates">
            <div className="inner">
                <h2>Principais Templates </h2>
                <p>Temos alguns templates já prontos para acelerar a sua entrega. Escolha entre eles ou consulte valores para seu template personalizado.</p>
                <div className="clients-container">
                    {/* Layout Desktop */}
                    <div className="clients-desktop">
                        {clients.map((client, index) => (
                            <div key={index} className="client-item">
                                <img src={client.image} alt={client.title} />
                                <div className="client-info">
                                    <h3>{client.title}</h3>
                                    <p>{client.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Layout Mobile */}
                    <div className="clients-mobile">
                        {clients.map((client, index) => (
                            <div key={index} className="client-item">
                                <img src={client.image} alt={client.title} />
                                <div className="client-info">
                                    <h3>{client.title}</h3>
                                    <p>{client.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Clients;
